export default __webpack_public_path__ + "static/media/emerald-tag.0d33e181.png";